import React, { useEffect } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { playerStyles } from 'root/src/client/web/commonStyles'
import classNames from 'classnames'

const TwitterEmbeddedContent = ({ classes, embeddedContent, isViewProjectPage = false }) => {
	useEffect(() => {
		const script = document.createElement('script')
		script.setAttribute('src', 'https://platform.twitter.com/widgets.js')
		script.setAttribute('async', 'true')
		document.head.appendChild(script)
	}, [])

	return (
		<div
			className={classNames(classes.twitterCommon,
				isViewProjectPage && classes.twitterViewProject)}
			/* eslint-disable */
			dangerouslySetInnerHTML={{ __html: embeddedContent }}
			/* eslint-enable */
		/>
	)
}

export default withStyles(playerStyles, { name: 'MuiTwitterEmbeddedContent' })(TwitterEmbeddedContent)
